import { axiosClient } from '@nx-frontend/shared/api';
import { generalEnv } from '@nx-frontend/shared/env';
import { NoteDto } from '@nx-frontend/shared/types';
import { GetNoteParams, GetNoteOptions } from '@nx-frontend/shared/types';
import { getDump } from './get-dump';

export async function getNote(
  { workspaceId, noteId }: GetNoteParams,
  options: GetNoteOptions
): Promise<NoteDto | null> {
  const { userId } = options;
  let note: NoteDto | null = null;

  try {
    const response = await axiosClient.get<NoteDto>(
      `${generalEnv.noteServiceUrl}/v1/workspaces/${workspaceId}/notes/${noteId}`,
      {
        headers: {
          Authorization: `internal ${userId}:auto`,
        },
      }
    );
    note = response.data;
    // set dump to note
    if (options.fetchDump && note.type === 'note') {
      note.dump = await getDump({ workspaceId, noteId }, options);
    }
  } catch (err) {
    console.log(`getNote error: ${err}`);
  }

  return note;
}
